<div class="row">
    @for (consumptionAgent of consumptionAgents; track $index) {
        <div class="col-sm-12 col-md-6 col-lg-4 pb-3">
            <app-consumption-card
                [consumptionAgent]="consumptionAgent"
                [buildingNo]="buildingNo"
                (editConsumptionAgent)="editAgent($event.reportId, $event.agentName)"
                (deleteConsumptionAgent)="deleteAgent($event.reportId, $event.agentName)"
                (duplicateConsumptionAgent)="duplicateAgent($event)" />
        </div>
    } @empty {
        <div class="col-12">
            <div class="alert alert-warning text-center m-3" role="alert">
                {{
                    ('table_NO_DATA_FROM_SOURCE' | translate: 'online' : 'common')
                        .replace('{0}', 'monitoring_consumption_agents' | translate)
                        .replace('{1}', 'monitoring_create_consumption_agent' | translate)
                }}
            </div>
        </div>
    }
</div>
